import React, {useContext} from 'react'
import '../styles/login.css'
import logo from '../Clear Logo.png'
import {Link} from 'react-router-dom'
import { config } from '../server'
import { PlanContext } from '../Store'
import '../App.css';
import { useAuth0 } from '@auth0/auth0-react';
const address = config.url.API_URL

const Plans = () => {
    const [, setPlan] = useContext(PlanContext)
   // const [userDep] = useContext(IsLoggedContext)
    const { user, isLoading, isAuthenticated } = useAuth0()

const handlePlan = async (planType) => {
    if (isAuthenticated) {
    const requestOptions = {
		method: 'POST',
		headers: { 
		'content-type': 'application/json' },
		body: JSON.stringify({ name: user.nickname, plan: planType, email: user.email, picture: user.picture})
	};
    const res = await fetch(address + '/plans', requestOptions)
    const data = await res.json()
    setPlan(data.planType)
}
}
    if(isLoading) {
        return (
            <div>
                Loading...
            </div>
        )
    }

    return (
        isAuthenticated && <>
    <div className="level-item">
        <div>
                <header className="App-header">
			<div className="loginContainer">
				<div className="loginOverlay"></div>
			</div>
            <div className="loginForm">
				<Link to="/" style={{paddingTop: 10}}>
					<img src={logo} alt="" className="loginLogo"></img>
				</Link>
				<h1>Clusterfy</h1>
                {user.nickname}
				<p>Achieve your greatest potential.</p>
                <h2 style={{fontWeight: 'bold'}}>Learner Track</h2>
                <h3 style={{fontWeight: 'bold'}}>Free</h3>
                <div>
                Includes
                </div>
                <div>
                    Access to list of tutors
                </div>
                <div>
                    Video Chat
                </div>
                <div>
                    Study sets
                </div>
                <button className="tealBtn" onClick={() => handlePlan('parent')}>Continue</button>
            </div>
            </header>
    </div>


        <div style={{paddingLeft: '10%'}}>
            <header className="App-header">
            <div className="loginForm">
            <Link to="/" style={{paddingTop: 10}}>
					<img src={logo} alt="" className="loginLogo"></img>
				</Link>
				<h1>Clusterfy</h1>
                {user.nickname}
				<p>Achieve your greatest potential.</p>
                <div>
                    <h2 style={{fontWeight: 'bold'}}>Tutor Track</h2>
                </div>
                <h3 style={{fontWeight: 'bold'}}>Free</h3>
                <div>
                Includes
                </div>
                <div>
                    Advertisement of your services
                </div>
                <div>
                    Video Chat
                </div>
                <div>
                    Study sets
                </div>
                <button className="tealBtn" onClick={() => handlePlan('tutor')}>Continue</button>
            </div>
            </header>

    </div>
</div>



        </>
    )
}

export default Plans